module.exports = __webpack_public_path__ + "static/media/lahore-xray.555cc357.svg";